export const ALLOWED_FILE_TYPES = ["image/gif", "image/jpeg", "image/png"];
